import { TDrawdownRepaymentSchedule } from './repaymentSchedule.types';

export const getTotalRepaymentAmount = (
    repaymentSchedule: TDrawdownRepaymentSchedule
): number | null => repaymentSchedule.summary.total_payable ?? null;
